/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Checkbox } from 'cdk-radial';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getIsPaymentChecked, selectPrintedOkChecks } from '../../PrintChecks';
import { ERROR_CODE, STATUS } from '../constants';
import { StyledCheckbox } from './styled';
import type { CheckInfoType } from 'adapters/types';

export const PrintedOKCheckbox = ({
  data
}: {
  data: CheckInfoType;
}): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const isChecked = useAppSelector(getIsPaymentChecked(data));
  const onChange = useCallback(
    ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>): void => {
      dispatch(selectPrintedOkChecks({ checks: [data], selected: checked }));
    },
    [data, dispatch]
  );
  return (
    <StyledCheckbox>
      <Checkbox
        dataTestId="printed-ok-checkbox"
        id={`printed-ok-${data.vendorNo}`}
        hideLabel
        name="printed-ok"
        checked={isChecked}
        onChange={onChange}
        isDisabled={
          data.status === STATUS.FAILED && data.errorCode === ERROR_CODE.E1342
        }
      />
    </StyledCheckbox>
  );
};
